<div class="password-form-wrapper">
  <!-- form -->
  <form [formGroup]="form" class="password-form" *ngIf="form">
    <!-- password -->
    <app-form-input-password [field]="'password'" [formControl]="f['password']"
      [feedback]="false" formControlName="password"></app-form-input-password>
    <!-- password repeat -->
    <app-form-input-password [field]="'passwordRepeat'" [formControl]="f['passwordRepeat']"
      [feedback]="false" formControlName="passwordRepeat"></app-form-input-password>
  </form>
  <!-- buttons -->
  <div class="buttons">
    <p-button [label]="'button.cancel' | translate" severity="secondary" (click)="cancel()"/>
    <p-button [label]="'button.save' | translate" severity="contrast" (click)="save()"/>
  </div>
</div>